<span>&copy; {{settings.app.year}} - {{ settings.app.name }} v{{version}}</span>
